import dbRepository from "./dbRepository";

function publish(name, detail) {
  if (typeof window === "undefined" || typeof window.dispatchEvent !== "function") return;
  window.dispatchEvent(new CustomEvent(name, { detail }));
}

function update(repeatingEventId, repeatingEvent) {
  const run = async () => {
    const { requireOnline, saveRepeatingEvent } = require("../sync/sessionSync.js");
    requireOnline();
    return saveRepeatingEvent(repeatingEventId, repeatingEvent);
  };
  return run().catch((error) => {
    const message =
      (error && error.code === "OFFLINE" && "网络不可用") ||
      (error && error.message) ||
      "同步失败";
    publish("sync-write-failed", { docType: "repeating_event", docId: String(repeatingEventId), message });
    throw error;
  });
}

function remove(repeatingEventId) {
  const id = String(repeatingEventId);
  const run = async () => {
    const { requireOnline, deleteRepeatingEvent } = require("../sync/sessionSync.js");
    requireOnline();
    return deleteRepeatingEvent(id);
  };
  return run().catch((error) => {
    const message =
      (error && error.code === "OFFLINE" && "网络不可用") ||
      (error && error.message) ||
      "同步失败";
    publish("sync-write-failed", { docType: "repeating_event", docId: id, message });
    // Still drop local IDB so UI stays consistent offline / after conflict
    try {
      let db_req = dbRepository.open();
      db_req.onsuccess = function (event) {
        let db = event.target.result;
        dbRepository.delete(db, "repeating_events", id);
      };
    } catch (_) {
      /* ignore */
    }
    throw error;
  });
}

export default {
  update,
  remove,
};
